import {
    post,
    get,
    del,
    put
} from './http'
export default {
    // 获取漏洞列表
    getVulList(param){
        return get('/cve/',param)
    },

    // 获取漏洞详情
    getVulDetail(cve_id){
        return get(`/cve/${cve_id}/`)
    },

    // 获取漏洞列表参数
    getVulTags(){
        return get('/cve/index/tags/')
    },

    // 获取投毒列表
    getPoisonList(param){
        return get('/back_injection/',param)
    },
    
     // 获取投毒统计详情
    getPoisonDeatil(id){
        return get(`/back_injection/${id}/`)
    }

}